export const ADMIN = 'admin'
export const DEVELOPER = 'developer'
export const USER = 'user'